export default __webpack_public_path__ + "static/media/side_menu_bg.cfa42910.svg";